import NavigableValidation from "./navigableValidation";
import NavigableValidator, {INavigableValidatorOptions} from "../navigableValidators/navigableValidator";
import {IErrorNavOpts} from "~/models/validationError";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import scrollToElement from "~/helpers/scrollToElement";
import ObjectModelTrigger from "~/models/objectModelTriggers/objectModelTrigger";
import ObjectModelTriggersValidator from "~/models/navigableValidators/objectModelTriggersValidator";
import ModelMapping from "~/models/mapping/modelMapping";
import {
  ModelMappingCantAddValues,
  ModelMappingUpdateRules
} from "../../../formability/mappingBuilder/enums/model-mapping-rules";
import {ErrorType} from "~/enums/ErrorType";
import {ObjectHelper} from "~/helpers/objectHelper";

export default class ObjectModelTriggerValidation extends NavigableValidation<ObjectModelTrigger> {
  model: ObjectModelTrigger;
  _validators: NavigableValidator<ObjectModelTrigger>[] =[
    new ObjectModelTriggersValidator({
      section: ValidationModalSection.Triggers
    })
  ];

  get validators() {
    return this._validators;
  }

  hasValidatorFor(field: string): boolean {
    return this._validators.some(it => it.field === field);
  }

  errorNavOpts(validator, field: string, value?): IErrorNavOpts {
    let base = super.errorNavOpts(validator, field, value)
    Object.assign(base, {
      query: {selectedId: this.model.client_id},
      targetElementId: this.model.idForProp(field),
    });
    return base;
  }

  async scrollToAndSelectBlankLabel(): Promise<JQuery> {
    const $label = $(`#scroll-to-label-${this.model.client_id}`);
    await scrollToElement({
      $el: $label,
      $container: $("div.scroll-area.work-area")
    })

    return $label;
  }
}